if (gsap.registerPlugin(ScrollTrigger), window.matchMedia("(min-width: 992px)").matches) {
    const divA = document.querySelector(".image-media-1"),
        divB = document.querySelector(".desktop-content");
    var paddingTop = 0;
    if (divA && divB) {
        const heightA = divA.offsetHeight,
            heightB = divB.offsetHeight;
        paddingTop = (heightA - heightB) / 2, divB.style.paddingTop = `${paddingTop}px`
    }
    paddingTop = paddingTop + 75;
    const pinnedElement = divB,
        rightDiv = document.querySelector(".iwtp-img-wrap"),
        pinText = document.querySelector(".pin-text");
    var heightDiff = 0;
    if (divA && pinText) {
        heightDiff = (divA.offsetHeight - pinText.offsetHeight) / 2;
    }
    heightDiff < 0 && (heightDiff = 0);
    const heightDifference = rightDiv && pinnedElement ? rightDiv.offsetHeight - pinnedElement.offsetHeight - heightDiff : 0;
    if (pinText) {
        ScrollTrigger.create({
            trigger: ".image-with-text-process",
            start: `top center-=${paddingTop+75}px`,
            end: `+=${heightDifference}`,
            pin: ".pin-text",
            pinSpacing: !1,
            scrub: !0
        });
    }
    gsap.utils.toArray(".iwtp-block:not(:first-child)").forEach((section, index) => {
        ScrollTrigger.create({
            trigger: section,
            start: `top center`,
            end: `top center`,
            scrub: !0,
            onEnter: () => {
                gsap.set(`.iwtp-desktop-block-${index+2}`, {
                    alpha: 1,
                    pointerEvents: "all"
                }), gsap.set(`.iwtp-desktop-block-${index+1}`, {
                    alpha: 0,
                    pointerEvents: "none"
                }), gsap.set(`.image-media-${index+2}`, {
                    alpha: 1,
                    pointerEvents: "all"
                }), gsap.set(`.image-media-${index+1}`, {
                    alpha: .5,
                    pointerEvents: "none"
                })
            },
            onEnterBack: () => {
                gsap.set(`.iwtp-desktop-block-${index+1}`, {
                    alpha: 1,
                    pointerEvents: "all"
                }), gsap.set(`.iwtp-desktop-block-${index+2}`, {
                    alpha: 0,
                    pointerEvents: "none"
                }), gsap.set(`.image-media-${index+1}`, {
                    alpha: 1,
                    pointerEvents: "all"
                }), gsap.set(`.image-media-${index+2}`, {
                    alpha: .5,
                    pointerEvents: "none"
                })
            }
        })
    }), window.addEventListener("load", function() {
        ScrollTrigger.refresh()
    })
}
//# sourceMappingURL=/cdn/shop/t/3/assets/our-story.js.map?v=139289832856958805121747808801